var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHtml5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m108.4 0h23v22.8h21.2v-22.8h23v69h-23v-23h-21v23h-23.2zm97.6 23h-20.3v-23h63.7v23h-20.4v46h-23zm53.5-23h24.1l14.8 24.3 14.8-24.3h24.1v69h-23v-34.2l-16.1 24.8-16.1-24.8v34.2h-22.6zm89.2 0h23v46.2h32.6v22.8h-55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.6 471-33-370.4h362.8l-33 370.2-148.7 41.2",
    fill: "#ff4c1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 480.5v-349.5h148.3l-28.3 316z",
    fill: "#ff651e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142 176.3h114l16.951 22.7-16.951 22.7h-64.2l4.2 46.5h60l16.951 23.549-16.951 21.751h-101.6zm14.4 160h45.6l3.2 36.3 50.8 13.6 19.127 22.66-19.127 24.74-93.2-26z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.6 176.3h-113.8v45.4h109.6zm-8.3 91.9h-105.5v45.4h56l-5.3 59-50.7 13.6v47.2l93-25.8z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHtml5);
export default __webpack_public_path__ + "static/media/icon_html5.b29c74b7d30710f05cc6c8b08328fe20.svg";
export { ForwardRef as ReactComponent };